import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { Comment, CommentsPaginated } from '@app/entities/models/comment.model';

export interface CommentRepository {
  getComments(content_id: string, pageRequest: number, last_viewed_id?: number): Observable<CommentsPaginated>;
  getCommentsHighlighted(content_id: string): Observable<Comment[]>;
  getCommentById(comment_id: number): Observable<Comment>;
  createComment(
    content_id: number,
    comment: string,
    translation_key: string,
    parent_comment_id?: number,
    representedUser?: string
  ): Observable<Comment>;
  deleteComment(comment_id: number): Observable<object>;
  updateComment(comment_id: number, comment: string): Observable<Comment>;
}

export const COMMENT_REPOSITORY = new InjectionToken<CommentRepository>('COMMENT_REPOSITORY');
